import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';

import { environment } from '@environment';

import { Workspace } from './settings/workspace.model';
import { Result } from '@common/types/http-types';
import { StorageService } from '@common/services/storage.service';
import { AccountService } from './account.service';

/**
 * It's a workaround to fetch the workspace before the route resolved;
 * The problem is that even child routes guards triggers before the parent resolver
 * @constructor
 */
export const WorkspaceGuard: CanActivateFn = () => {
  const http = inject(HttpClient);
  const $storage = inject(StorageService);
  const $account = inject(AccountService);
  const workspaceId = $storage.get('workspace');
  let httpParams = new HttpParams();
  if (workspaceId) {
    httpParams = httpParams.set('workspaceId', workspaceId);
  }
  return http
    .get<Result<Workspace>>(`${environment.baseUrl}/v1/user/workspace`, { params: httpParams })
    .pipe(map(res => {
      $account.workspace.set(res.data);
      $storage.set('workspace', `${res.data.id}`);
      return true;
    }));
};